// Delivery Detail Models

export interface DeliveryDetail {
    id?: number;
    delivery_id?: number;
    sales_order_detail_id?: number;
    sales_order_detail?: string;
    product?: string;
    batch?: string;
    batch_id?: number;
    batch_barcode?: string;
    batch_name?: string;
    quantity?: number;
    unit?: string;
    position?: number;
    observations?: string;
}

export interface DeliveryDetailDataForm {
    id?: number;
    delivery_id?: number;
    sales_order_detail_id?: number;
    batch_id?: number;
    quantity?: number;
    unit_id?: number;
    position?: number;
    observations?: string;
    /** Heredados del pedido (solo lectura; los devuelve el edit) */
    price?: number;
    price_currency?: string;
    quantity_unit?: string;
    price_unit?: string;
}

export const defaultDeliveryDetailDataForm: DeliveryDetailDataForm = {
    delivery_id: undefined,
    sales_order_detail_id: undefined,
    batch_id: undefined,
    quantity: 0,
    position: undefined,
    observations: ''
};

